(function() {
  'use strict';
  
  angular
    .module('app.data', []);
  
})();